import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M4 12.027c0-.456.37-.827.827-.827H17.96l-4.607-4.8a.827.827 0 0 1 1.194-1.146l5.924 6.174a.827.827 0 0 1 0 1.144l-5.924 6.174a.827.827 0 0 1-1.194-1.145l4.555-4.747H4.828A.827.827 0 0 1 4 12.027"
    }, null, -1)
  ]))]))
}
export default { render: render }